import styled from 'styled-components';
import { Modal, Card, Collapse } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    background: #1890ff;
    border-radius: 20px 20px 0 0;
    padding: 24px 32px;
    border-bottom: none;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);

    .ant-modal-title {
      color: white;
      font-size: 22px;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  .ant-modal-body {
    padding: 24px;
    background: #fafafa;
  }

  .ant-modal-footer {
    border-top: 1px solid #e8e8e8;
    padding: 16px 24px;
    background: white;
  }
`;

export const CategoryCard = styled(Card)`
  margin-bottom: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 20px;
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 2px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    border-color: #1890ff;
    box-shadow: 
      0 12px 32px rgba(24, 144, 255, 0.2),
      0 6px 16px rgba(24, 144, 255, 0.15);
    transform: translateY(-4px) scale(1.01);
  }

  .ant-card-head {
    background: #f0f7ff;
    border-radius: 20px 20px 0 0;
    border-bottom: 2px solid #e8e8e8;
    padding: 20px 24px;
    min-height: auto;
  }

  .ant-card-head-title {
    font-size: 15px;
    font-weight: 600;
    color: #262626;
  }

  .ant-card-body {
    padding: 16px;
  }
`;

export const RegisteredParticipantBadge = styled.div`
  padding: 6px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 16px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 4px;
  box-shadow: 0 1px 2px rgba(82, 196, 26, 0.15);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2);
  }
`;

export const SelectedParticipantChip = styled.div`
  padding: 6px 12px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 16px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 4px;
  box-shadow: 0 1px 2px rgba(24, 144, 255, 0.15);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const StyledCollapse = styled(Collapse)`
  background: transparent;
  border: none;

  .ant-collapse-item {
    background: white;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .ant-collapse-header {
      padding: 16px 20px;
      background: #f8f9fa;
      border-radius: 12px;
      font-weight: 500;
    }

    .ant-collapse-content {
      border-top: 1px solid #e8e8e8;
      background: white;
      border-radius: 0 0 8px 8px;
    }

    .ant-collapse-content-box {
      padding: 20px;
    }
  }
`;

